import React from 'react';
import {Col, Container, Row, Tabs, Tab, Accordion} from "react-bootstrap";
import {Link} from 'gatsby';

function Appbuild(props) {
    return (
        <div className="services_buildapp p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Help You Grow">
                            <h2>Digital Marketplaces To Help You Grow</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>Our digital marketplace services are for businesses and enterprises looking to build and
                            launch solutions to manage their customers’ digital transformation journeys.</p>
                    </Col>
                </Row>
                <Row className="services_bg ">
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="services_tabs deskstop_version">
                        <Tabs defaultActiveKey="0" transition={false}>

                            <Tab eventKey="0" title="Gaming">
                                <div className="content_tabs">
                                    <h2>Ether Legend</h2>
                                    <p>The gaming industry is among the most profitable industries around the globe,
                                        but not everyone can build a perfect game. At TekRevol, our expert team of
                                        software engineers and developers create games following industry standards:
                                        cross-platform to cloud functionality, stunning graphics, and fluid player
                                        experience. Our games, gaming platforms, and solutions are turnkey products
                                        with high monetization potential.</p>
                                    <Link to="/case-studies/ether-legends">See case
                                        study</Link>
                                </div>
                            </Tab>
                            <Tab eventKey="1" title="Healthcare">
                                <div className="content_tabs">
                                    <h2>AMJ Wellness</h2>
                                    <p>Nothing stops us from developing world-class software programs that improve
                                        access to healthcare services. TekRevol comprehensively caters to the
                                        requirements of the healthcare and wellness industry, building technically
                                        sound, experience-focused, and user-centric digital solutions. Our teams
                                        understand the dynamics of working in this industry and are aware of the
                                        stakes.</p>
                                    <Link to="/case-studies/amj-wellness">See case
                                        study</Link>
                                </div>
                            </Tab>
                            <Tab eventKey="2" title="Real Estate">
                                <div className="content_tabs">
                                    <h2>Muirfield</h2>
                                    <p>TekRevol has a holistic, agile development approach. We develop technology
                                        solutions that are not packed with features but deliver actual value to the
                                        end-users and help achieve the business objectives. The real estate industry
                                        challenges are different, requiring a totally unique course of action.</p>
                                    <Link to="/case-studies/muirfield">See case
                                        study</Link>
                                </div>
                            </Tab>
                            <Tab eventKey="3" title="Education">
                                <div className="content_tabs">
                                    <h2>Project Impact</h2>
                                    <p>EdTech has been getting increasingly popular ever since remote learning became
                                        famous. It offers benefits that physical learning does not, which is why
                                        institutes and students are opting for e-learning solutions in many parts of the
                                        world. TekRevol incorporates modern practices to build a high-coverage,
                                        end-to-end learning management system guaranteeing a brighter future.</p>
                                    <Link to="/case-studies/impact">See case
                                        study</Link>
                                </div>
                            </Tab>
                            <Tab eventKey="4" title="Music">
                                <div className="content_tabs">
                                    <h2>Soundly</h2>
                                    <p>Some leading digital programs are from the music industry, ranking atop the
                                        software stores with thousands of hours of music streamed daily. TekRevol
                                        develops feature-rich, robust music applications specific to the requirements
                                        that compete against the top apps in the industry. We build apps that’d build
                                        your online reputation in the media.</p>
                                    <Link to="/case-studies/soundly">See case
                                        study</Link>
                                </div>
                            </Tab>
                            <Tab eventKey="5" title="Lifestyle">
                                <div className="content_tabs">
                                    <h2>Stop Vaping</h2>
                                    <p>A vast market worldwide uses various lifestyle digital products, from web apps to
                                        smartwatch widgets to desktop programs. These digital solutions provide helpful
                                        content, information, and products to the users and present immense potential
                                        for making money through multiple monetization models. TekRevol can build the
                                        right lifestyle solution for you.</p>
                                    <Link to="/case-studies/stop-vaping">See case
                                        study</Link>
                                </div>
                            </Tab>

                        </Tabs>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="services_tabs mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="01">
                                <Accordion.Item eventKey="01">
                                    <Accordion.Header>Ether Legend</Accordion.Header>
                                    <Accordion.Body>
                                        <p>The gaming industry is among the most profitable industries around the globe,
                                            but not everyone can build a perfect game. At TekRevol, our expert team of
                                            software engineers and developers create games following industry standards:
                                            cross-platform to cloud functionality, stunning graphics, and fluid player
                                            experience. Our games, gaming platforms, and solutions are turnkey products
                                            with high monetization potential.</p>
                                        <Link to="/case-studies/ether-legends">See case
                                            study</Link>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="02">
                                    <Accordion.Header>AMJ Wellness</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Nothing stops us from developing world-class software programs that improve
                                            access to healthcare services. TekRevol comprehensively caters to the
                                            requirements of the healthcare and wellness industry, building technically
                                            sound, experience-focused, and user-centric digital solutions. Our teams
                                            understand the dynamics of working in this industry and are aware of the
                                            stakes.</p>
                                        <Link to="/case-studies/ether-legends">See case
                                            study</Link>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="03">
                                    <Accordion.Header>Muirfield</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol has a holistic, agile development approach. We develop technology
                                            solutions that are not packed with features but deliver actual value to the
                                            end-users and help achieve the business objectives. The real estate industry
                                            challenges are different, requiring a totally unique course of action.</p>
                                        <Link to="/case-studies/muirfield">See case
                                            study</Link>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="04">
                                    <Accordion.Header>Project Impact</Accordion.Header>
                                    <Accordion.Body>
                                        <p>EdTech has been getting increasingly popular ever since remote learning
                                            became famous. It offers benefits that physical learning does not, which is
                                            why institutes and students are opting for e-learning solutions in many
                                            parts of the world. TekRevol incorporates modern practices to build a
                                            high-coverage, end-to-end learning management system guaranteeing a brighter
                                            future.</p>
                                        <Link to="/case-studies/impact">See case
                                            study</Link>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="05">
                                    <Accordion.Header>Soundly</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Some leading digital programs are from the music industry, ranking atop the
                                            software stores with thousands of hours of music streamed daily. TekRevol
                                            develops feature-rich, robust music applications specific to the
                                            requirements that compete against the top apps in the industry. We build
                                            apps that’d build your online reputation in the media.</p>
                                        <Link to="/case-studies/soundly">See case
                                            study</Link>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="06">
                                    <Accordion.Header>Stop Vaping</Accordion.Header>
                                    <Accordion.Body>
                                        <p>A vast market worldwide uses various lifestyle digital products, from web
                                            apps to smartwatch widgets to desktop programs. These digital solutions
                                            provide helpful content, information, and products to the users and present
                                            immense potential for making money through multiple monetization models.
                                            TekRevol can build the right lifestyle solution for you.</p>
                                        <Link to="/case-studies/stop-vaping">See case
                                            study</Link>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="services_grade_tabs">
                        <Tabs defaultActiveKey="0">
                            <Tab eventKey="0" title="Silver">
                                <div className="tab_hour">
                                    <h4>1172 Hours<span>Average Development Time</span></h4>
                                    <h4>07 Months<span>Average Project Length</span></h4>
                                </div>
                            </Tab>
                            <Tab eventKey="1" title="Gold">
                                <div className="tab_hour">
                                    <h4>1619 Hours<span>Average Development Time</span></h4>
                                    <h4>09 Months<span>Average Project Length</span></h4>
                                </div>
                            </Tab>
                            <Tab eventKey="2" title="Platinum">
                                <div className="tab_hour">
                                    <h4>3116 Hours<span>Average Development Time</span></h4>
                                    <h4>18 Months<span>Average Project Length</span></h4>
                                </div>
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Appbuild;